import content from './reducer';

export { default as contentTypes } from './types';
export { default as contentActions } from './actions';

export default content;